import styles from './ShareDialog.module.scss';
import { ButtonV2 } from '../../ButtonV2/ButtonV2';
import { icons } from '../../../assets';
import { SingleInputForm } from '../../../common/SingleInputForm/SingleInputForm';
import { InputUI } from '../../hookForm/InputController';
import { useEffect, useState } from 'react';
import Comments from '../../../assets/images/configurator/comments-ghost.png';
import { Image } from '../../../common';
import {
  configuratorActions,
  selectIsDataChanged,
} from '../../../redux/slicers/configurator/configurator.slicer';
import { useDispatch, useSelector } from 'react-redux';
import { SCENE_NAME_MAX_LENGTH } from '../../../constants/validationConstants';
import { sanitizeNameInConfigurator } from '../utils';
import { createSimpleNameValidator } from '../../../helpers/validationHelper';
import { openYesNoDialog } from '../../../hooks/useInfoDialogaActions';
import { closeInfoDialog } from '../../../redux/slicers/infoDialogSlicer';
import { createAllSceneToken, updateAllSceneToken } from '../../../api/configuratorApi';
import { successToastV2 } from '../../../helpers/toastHelper';

const { AddCircleIcon, RemoveCircleIcon } = icons;

export const CreateLink = ({
  onClose,
  data,
  groupData,
  scenes,
  getCustomLinks,
  customLinks = [],
}) => {
  const [name, setName] = useState('');
  const [loader, setLoader] = useState(false);
  const [addedScenes, setAddedScenes] = useState([]);
  const [allScenes, setAllScenes] = useState([]);
  const isDataChanged = useSelector(selectIsDataChanged);
  const dispatch = useDispatch();
  const v2 = data?.version_type === 'V2';
  const isNameSame = groupData?.name?.trim() === name?.trim();

  useEffect(() => {
    const filteredScenes = scenes.filter((val) => val?.scene_data?.is_enable);
    setAllScenes(filteredScenes);
    dispatch(configuratorActions.setIsDataChanged(false));
  }, [scenes]);

  useEffect(() => {
    groupData?.name && setName(groupData?.name);
  }, [groupData?.name]);

  useEffect(() => {
    if (groupData?.all_scene?.length) {
      const groupScenes = [];
      scenes?.map((val) => {
        if (groupData?.all_scene.indexOf(val.scene) !== -1) {
          groupScenes.push(val);
        }
      });
      setAddedScenes(groupScenes);
      updateAllScenes(groupScenes);
    }
  }, [scenes, groupData?.all_scene]);

  const changeName = (name) => {
    setName(name);
    if (groupData) {
      if (!isNameSame) {
        dispatch(configuratorActions.setIsDataChanged(true));
      } else {
        dispatch(configuratorActions.setIsDataChanged(false));
      }
    } else {
      dispatch(configuratorActions.setIsDataChanged(true));
    }
  };

  const saveLink = async () => {
    if (isDisabled()) return;
    setLoader(true);
    let result = {};
    if (!groupData) {
      const sceneIds = addedScenes?.map((val) => val.scene);
      result = await createAllSceneToken({
        id: data?.id,
        data: {
          name,
          scene: sceneIds,
        },
        v2,
      });
    } else {
      result = await updateAllSceneToken({
        id: data?.id,
        token: groupData?.unique_id,
        sceneLinkType: 'COMBINATION',
        data: {
          name,
        },
        v2,
      });
    }
    if (result?.status) {
      await getCustomLinks();
      successToastV2(`Custom link ${!groupData ? 'created' : 'updated'} successfully`);
      onClose();
      dispatch(configuratorActions.setIsDataChanged(false));
    }
    setLoader(false);
  };

  const isDisabled = () => {
    return (
      !name.trim() ||
      addedScenes?.length < 2 ||
      loader ||
      (groupData && isNameSame) ||
      validateName(name)
    );
  };

  const updateAllScenes = (addedScenes) => {
    const ids = addedScenes.map((val) => val.scene);
    let allData = [...scenes];
    allData = allData.filter((val) => ids.indexOf(val.scene) === -1);
    setAllScenes(allData);
  };

  const onAddScene = (scene) => {
    const scenes = [...addedScenes];
    scenes.push(scene);
    setAddedScenes(scenes);
    updateAllScenes(scenes);
    dispatch(configuratorActions.setIsDataChanged(true));
  };

  const onRemoveScene = (scene) => {
    let scenes = [...addedScenes];
    scenes = scenes.filter((val) => val.scene !== scene.scene);
    setAddedScenes(scenes);
    updateAllScenes(scenes);
    dispatch(configuratorActions.setIsDataChanged(true));
  };

  const validateName = createSimpleNameValidator({
    currentItem: groupData,
    list: customLinks,
    nameKey: 'name',
  });

  const closePopup = () => {
    if (isDataChanged) {
      const cancel = () => {
        closeInfoDialog();
      };
      openYesNoDialog({
        title: 'Do you want to close current custom link editing?',
        description: 'All unsaved changes will be lost!',
        onClose: () => {
          cancel();
        },
        onCancelClick: () => {
          cancel();
        },
        onButtonClick: () => {
          cancel();
          onClose();
          dispatch(configuratorActions.setIsDataChanged(false));
        },
      });
      return;
    }
    onClose();
  };

  const sceneItem = (scene, showDeleteIcon = false) => {
    return (
      <div className={`w-100 d-flex ${styles.createLinkItem}`} key={scene.scene}>
        <div
          className={`${styles.createLinkListImage} d-flex justify-content-start align-items-center`}>
          <Image
            src={scene?.thumbnail}
            rounded={false}
            ratio={1.2}
            iconFontSize={18}
            placeholderWhileLoading
          />
        </div>
        <div
          className={`d-flex justify-content-start align-items-center px-2 ${styles.createLinkListName}`}>
          <span className={`${styles.listItemTitle} ellipsis`} title={scene.name}>
            {scene.name}
          </span>
        </div>
        <div
          className={`d-flex justify-content-end align-items-center ${styles.createLinkListIcon}`}>
          {!showDeleteIcon && (
            <ButtonV2
              className={styles.transparentBtn}
              onClick={() => onAddScene(scene)}
              disabled={groupData}>
              <AddCircleIcon />
            </ButtonV2>
          )}
          {showDeleteIcon && (
            <ButtonV2
              className={styles.transparentBtn}
              onClick={() => onRemoveScene(scene)}
              disabled={groupData}>
              <RemoveCircleIcon />
            </ButtonV2>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={`${styles.createLinkContainer} w-100 h-100 `}>
      <div className={`w-100 h-100 ${styles.leftRightSpacing}`}>
        <div className="w-100 mt-3">
          <SingleInputForm
            InputComponent={InputUI}
            label="Name"
            className="w-100"
            name="name"
            placeholder="Enter name"
            value={name}
            sanitize={(value) =>
              sanitizeNameInConfigurator(value, { maxLength: SCENE_NAME_MAX_LENGTH })
            }
            onEnterPress={saveLink}
            validate={validateName}
            autoComplete="off"
            theme="v2"
            onChange={changeName}
            autoFocus
          />
        </div>
        <div className={`w-100 d-flex mt-3 ${styles.createLinkItemContainer}`}>
          <div className="w-50 h-100">
            <div className="w-100 d-flex justify-content-start align-items-center">
              <span className={styles.listItemTitle}>All scenes</span>
            </div>
            <div className={`w-100 ${styles.customLinksContainer} ${styles.overflowScrollHide}`}>
              {allScenes.map((scene) => sceneItem(scene))}
            </div>
          </div>
          <div className="w-50 h-100">
            <div className="w-100 d-flex justify-content-start align-items-center">
              <span className={styles.listItemTitle}>Added scenes</span>
            </div>
            <div className={`w-100 ${styles.customLinksContainer} ${styles.overflowScrollHide}`}>
              {!addedScenes?.length ? (
                <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                  <span className={styles.listItemTitle}>Add scenes</span>
                  <span className={`${styles.listItemDescription} mt-2`}>
                    All your added scenes will be visible here
                  </span>
                  <div
                    className="w-100 position-relative d-flex flex-column justify-content-center align-items-center"
                    style={{
                      marginTop: '-30px',
                    }}>
                    <img src={Comments} className="mt-2" height="115px" />
                    <img src={Comments} className={styles.comments} height="115px" />
                  </div>
                </div>
              ) : (
                addedScenes.map((scene) => sceneItem(scene, true))
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`w-100 d-flex justify-content-between align-items-center ${styles.footer}`}>
        <ButtonV2 color="white" size="xxs" onClick={closePopup} disabled={loader}>
          Back
        </ButtonV2>
        <ButtonV2
          color="dark"
          size="xxs"
          onClick={saveLink}
          disabled={isDisabled()}
          loading={loader}>
          Save
        </ButtonV2>
      </div>
    </div>
  );
};
